import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import moment from 'moment';
import { BatchProcessModuleType } from 'src/app/enum/batch-processType';
import { AdditionalQuestionsService } from 'src/app/services/additional-questions.service';
import swal from 'sweetalert2';

@Component({
  selector: 'app-upload-fsan-number',
  templateUrl: './upload-FSAN-Number.component.html',
  styleUrls: ['./upload-FSAN-Number.component.scss']
})
export class UploadFSANNumberComponent implements OnInit {
    uploadFSANForm:FormGroup
    dateWithTime: string;
    FileExtention: string;
    fileName: string;
    isFileSelected: boolean = true;
    FsanFile: File;
    userImageBase64: string;
    documents: any=[];
    file:File
    BatchProcessModuleTypeEnum = BatchProcessModuleType.UploadFsanNumber
  constructor(private fb:FormBuilder,private additionalDataService:AdditionalQuestionsService) { }

  ngOnInit() {
    this.init()
  }
  init() {
    this.uploadFSANForm = this.fb.group({
        AttachmentFileName: [null,],
    });
}
selectFile(): void {
    const inputElement = document.createElement('input');
    inputElement.type = 'file';
    inputElement.style.display = 'none';
    document.body.appendChild(inputElement);
    inputElement.click();
    inputElement.addEventListener('change', async(event:any) => {
        const files: FileList = (event.target as HTMLInputElement).files;

        if (!files || files.length == 0) {
            swal.fire('Warning', 'Please upload file', 'warning');
            return;
        }
        this.dateWithTime = moment(new Date()).format(
            'YYYY-MM-DD HH:mm:ss'
        );
        this.fileName = files.item(0).name;
        this.file = files.item(0);
        var fileExtension = this.fileName.slice(
            this.fileName.lastIndexOf('.') + 1
        );
        var type =
            '|' + this.file.type.slice(this.file.type.lastIndexOf('/') + 1) + '|';
        var result =
            '|png|jpeg|jpg|pdf|doc|docx|xlsx'.indexOf(type) !== -1 ||
            '|png|jpeg|jpg|pdf|doc|docx|xlsx'.indexOf(fileExtension) !== -1;

        if (!result) {
            swal.fire(
                'Warning',
                `Please upload a Correct File Format (PNG, JPEG, JPG, PDF, DOC, DOCX)`,
                'warning'
            );
            this.fileName = ' ';
            this.dateWithTime = ' ';
            this.isFileSelected = true;
            return;
        }
        if (this.file.size > 4194304) {
            swal.fire(
                'Warning',
                `The this.file being uploaded can't be more than 4MB`,
                'warning'
            );
            this.fileName = ' ';
            this.dateWithTime = ' ';
            this.isFileSelected = true;
            return;
        }
        this.FileExtention = fileExtension;
        this.isFileSelected = false;
        this.FsanFile = this.file
        const reader1 = new FileReader();
        reader1.onloadend = () => {
            this.userImageBase64 = (<string>reader1.result).split(',')[1];
            this.userImageBase64 = `data:image/${fileExtension === 'jpg' || type === 'jpeg' ? 'jpeg' : 'png'};base64,${this.userImageBase64}`
        };


        reader1.readAsDataURL(files.item(0));
        reader1.onerror = function () { };
        document.body.removeChild(inputElement);
        let base64 = await this.convertToBase64(event.target.files[0]);

        this.documents.push({
            'FileData': base64,
            'fileName': this.file.name,
            'uploadedDate': moment().format('DD MMM YYYY hh:mm A'),
            'fileExtention': this.file.type,
            'fileType': this.file.type
        })
        this.uploadFSANForm.patchValue({AttachmentFileName:this.fileName})


    });
}
convertToBase64(file: any): any {
    return new Promise(async (resolve) => {
      if (file) {
        var reader = new FileReader();
        reader.onload = (readerEvt: any) => {
          var binaryString = readerEvt.target.result;
          resolve('data:image/png;base64,' + btoa(binaryString));
        }
        reader.readAsBinaryString(file);
      }
    })
  }
reset() {
    const txt = 'Are you sure want to delete?';
    const Yes = 'Yes';
    const No = 'No';
    swal.fire({
        text: txt,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#7D32DE',
        cancelButtonColor: '#23C00A',
        confirmButtonText: Yes,
        cancelButtonText: No,
    }).then((result) => {
        if (result.value) {
                this.fileName = "";
                this.dateWithTime = " ";
                this.isFileSelected = true;
                this.uploadFSANForm.controls['AttachmentFileName'].setValue(this.fileName);
        }
    });
}
SaveAllExcelSheets(){
    let payload: FormData = new FormData()
    payload.append('file', this.file)
    payload.append('BatchProcessModuleType', this.BatchProcessModuleTypeEnum.toString())


    this.additionalDataService.SaveAllExcelSheets(payload).subscribe(res=>{

    })
}
}
